import React from "react";
import "../styles/ContactUs.css";
import deliveryMan from "../../assets/delivery-man.png";

const ContactUs = () => {
  return (
    <section className="contact-section">
      <div className="contact-container">

        {/* LEFT CONTENT */}
        <div className="contact-left">
          <h2>Send your cargo with SCPL / FTL service</h2>

          <ul>
            <li>Best in class network with 8K pincodes reach</li>
            <li>Largest fleet of 7K trucks covering all key lanes</li>
            <li>Only provider of OBD on Bulk Cargo delivery</li>
            <li>Air Express to 2K cities within 96 hours</li>
            <li>Appointment based deliveries for all Marketplace Inwards</li>
          </ul>

          <img src={deliveryMan} alt="Delivery Man" />
        </div>

        {/* RIGHT FORM */}
        <div className="contact-form">
          <h3>Request a Call Back</h3>

          <form>
            <input type="text" placeholder="Your Full Name" />
            <input type="email" placeholder="Your Email Address" />
            <input type="tel" placeholder="Your Phone Number" />
            <textarea placeholder="Your query related messages"></textarea>
            <button type="submit">SUBMIT</button>
          </form>
        </div>

      </div>
    </section>
  );
};

export default ContactUs;
